import React, { FC } from "react";
import { Box, Typography } from "@mui/material";
import Qr from "../../../../components/Qr/Qr";

interface Props {
  url: string;
}

export const QrChannel: FC<Props> = ({ url }) => (
  <>
    <Typography fontSize={14} marginBottom={1}>
      Download the QR code below for packaging and other applications.
    </Typography>
    <Box sx={{ textAlign: "center" }}>
      <Qr url={url} variant="outlined" />
    </Box>
  </>
);
